import CloseIcon from '@mui/icons-material/Close';
import { Checkbox, IconButton, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

interface Props {
  file: File;
  index: number;
  onDelete: (e: Event) => void;
}

function VNFileTile({ file, index, onDelete }: Props) {
  const { setValue, watch } = useFormContext();

  const url = URL.createObjectURL(file);
  const checked = watch(`filesToSave.${index}.selected`);
  const isMov = file.name.toLowerCase().endsWith('.mov');

  let className = `vn-file-tile${checked ? ' active' : ''}`;
  if (isMov) {
    className = 'vn-file-tile is-mov';
  }
  useEffect(() => {
    className = `vn-file-tile${checked ? ' active' : ''}`;
    if (isMov) {
      className = 'vn-file-tile is-mov';
    }
  }, [checked]);

  let fileType;
  if (file.type.startsWith('image/')) {
    fileType = 'image';
  } else if (file.type.startsWith('video/')) {
    fileType = 'video';
  } else {
    fileType = 'unknown';
  }

  return (
    <div className={className}>
      <div className="file-header" role="button" tabIndex={0}>
        <div className="file-title">
          <Checkbox checked={checked} onChange={toggleCheck} />
          <Typography style={{ width: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {file.name}
          </Typography>
        </div>
        <IconButton
          aria-label="delete"
          size="small"
          style={{ padding: 0 }}
          onClick={(e) => {
            onDelete(e);
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>
      <div className="tile">
        <div className="file-preview">
          {fileType === 'image' && <img src={url} alt={file.name} className="file-image" />}
          {fileType === 'video' && (
            <canvas
              ref={(node) => {
                const canvasRef = node as HTMLCanvasElement | null;
                if (canvasRef) {
                  const video = document.createElement('video');
                  video.src = url;
                  video.onloadedmetadata = () => {
                    const midpoint = video.duration / 2;
                    video.currentTime = midpoint;
                  };
                  video.onseeked = () => {
                    canvasRef.width = video.videoWidth / 2;
                    canvasRef.height = video.videoHeight / 2;
                    const context = canvasRef.getContext('2d');
                    context?.drawImage(video, 0, 0, canvasRef.width, canvasRef.height);
                  };
                }
              }}
              className="file-video-thumbnail"
            />
          )}
        </div>
      </div>
    </div>
  );

  function toggleCheck() {
    setValue(`filesToSave.${index}.selected`, !checked);
  }
}

export default VNFileTile;
